import React, { useEffect } from 'react';
import { LinearProgress, Paper, Tabs, TextField, Typography, withStyles, Tab, makeStyles } from '@material-ui/core';
import DashboardTransaksi from './DashboardTransaksi';
import Autocomplete from '@material-ui/lab/Autocomplete';
import DashboardReview from './DashboardReview';
import LandingPage from './landingPage';
import api from './api';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        width: "100%",
        backgroundColor: theme.palette.background.paper
    },
    tabsIndicator: {
        backgroundColor: "#2a9c6c"
    },
    tabRoot: {
        "&:hover": {
            color: "red",
            opacity: 1
        },
        "&$tabSelected": {
            color: "red",
            fontWeight: theme.typography.fontWeightMedium
        },
        "&:focus": {
            color: "red"
        }
    },
    tabSelected: {},
    fab: {
        '& > *': {
            margin: theme.spacing(1),
        },
        position: 'fixed',
        right: 25,
        top: 65
    },
    extendedIcon: {
        marginRight: theme.spacing(1),
    },
}))


export default function Dashboard(props) {
    const classes = useStyles()
    const [value, setValue] = React.useState(0);

    const [listBulan] = React.useState([
        { id: '01', nama: 'Januari' },
        { id: '02', nama: 'Februari' },
        { id: '03', nama: 'Maret' },
        { id: '04', nama: 'April' },
        { id: '05', nama: 'Mei' },
        { id: '06', nama: 'Juni' },
        { id: '07', nama: 'Juli' },
        { id: '08', nama: 'Agustus' },
        { id: '09', nama: 'September' },
        { id: '10', nama: 'Oktober' },
        { id: '11', nama: 'November' },
        { id: '12', nama: 'Desember' },
    ])
    const [bulan, setBulan] = React.useState(null)
    const [listTahun, setFullYear] = React.useState([])
    const [pickTahun, setPickTahun] = React.useState(null)
    const [loading, setLoading] = React.useState(false)
    const [isDashboard, setIsDashboard] = React.useState(false)
    const forceUpdate = React.useReducer(bool => !bool)[1];

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    useEffect(() => {
        props.setShowNotif(true)
        getPermission(props)
        let year = new Date().getFullYear()
        let month = new Date().getMonth()
        let listTahun = []
        for (var i = year; i > year - 20; i--) {
            listTahun.push({ nama: String(i) })
        }
        setFullYear(listTahun)
        setBulan(listBulan[month])
        let idx = listTahun.findIndex((val) => val.nama === String(year))
        console.log(idx);
        if (idx > -1) {
            setPickTahun(listTahun[idx])
        }
        forceUpdate()
    }, [])

    const getPermission = (e) => {
        api.create().getPermission(2).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let data = response.data.data
                    setIsDashboard(data.read)
                    setLoading(true)
                }
            }
        })
    }

    return (
        <div>
            {loading && (
                <div>
                    {isDashboard ?
                        <Paper style={{ boxShadow: 'none' }} >
                            <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
                                <Tabs
                                    value={value}
                                    indicatorColor="primary"
                                    textColor="#2a9c6c"
                                    onChange={handleChange}
                                    aria-label="disabled tabs example"
                                    style={{ outline: 'null' }}
                                    classes={{ indicator: classes.tabsIndicator }}
                                >
                                    <Tab label="Transaksi" style={{ color: value === 0 ? '#2a9c6c' : 'black' }} />
                                    <Tab label="Antrian & Review" style={{ color: value === 1 ? '#2a9c6c' : 'black' }} />
                                </Tabs>
                                <div style={{ display: 'flex', alignItems: 'center', marginTop: 10, marginRight: 20 }}>
                                    <Autocomplete
                                        options={listBulan}
                                        getOptionLabel={(option) => option.nama}
                                        id="bulan"
                                        onChange={(event, newInputValue) => {
                                            setBulan(newInputValue)
                                            setLoading(false)
                                            setTimeout(() => {
                                                setLoading(true)
                                            }, 500);
                                        }}
                                        underlineShow={false}
                                        disableClearable
                                        style={{ width: 150, backgroundColor: 'white', borderRadius: 10, boxShadow: '5px 5px 10px 0 #999999', height: 40 }}
                                        renderInput={(params) =>
                                            <TextField
                                                {...params}
                                                InputProps={{ ...params.InputProps, disableUnderline: true }}
                                                margin="normal" style={{ paddingLeft: 20, paddingRight: 10, margin: 0 }}
                                            />}
                                        value={bulan}
                                    />
                                    <Autocomplete
                                        options={listTahun}
                                        getOptionLabel={(option) => option.nama}
                                        onChange={(event, newInputValue) => {
                                            setPickTahun(newInputValue)
                                        }}
                                        underlineShow={false}
                                        disableClearable
                                        style={{ width: 120, backgroundColor: 'white', borderRadius: 10, marginLeft: 10, boxShadow: '5px 5px 10px 0 #999999', height: 40 }}
                                        renderInput={(params) =>
                                            <TextField
                                                {...params}
                                                InputProps={{ ...params.InputProps, disableUnderline: true }}
                                                margin="normal" style={{ paddingLeft: 20, paddingRight: 10, margin: 0 }}
                                            />}
                                        value={pickTahun}
                                    />
                                </div>
                            </div>

                            {value === 0 ?
                                <DashboardTransaksi
                                    width={props.width}
                                    height={props.height}
                                    month={bulan}
                                    year={pickTahun}
                                />
                                :
                                <DashboardReview
                                    width={props.width}
                                    height={props.height}
                                    month={bulan}
                                    year={pickTahun}
                                />
                            }
                        </Paper>
                        :
                        <LandingPage
                            width={props.width}
                        />
                    }
                </div>
            )}
        </div>
    );
}